import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { TranslateMessageAction } from '../../domains/translatedMessages/actions.types';

import type { TranslatedMessages } from './types';

export type { TranslateMessageAction };

const initialState: TranslatedMessages = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TranslatedMessages, TranslateMessageAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MESSAGE.TRANSLATE_PENDING':
      return moveToPending(state, [action.payload.messageId]);
    case 'MESSAGE.TRANSLATE_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.messageId]: {
          id: action.payload.messageId,
          translatedBody: action.payload.translatedBody,
          translatedPlainTitle: action.payload.translatedPlainTitle,
          translatedPollAnswers: action.payload.translatedPollAnswers,
        },
      });
    case 'MESSAGE.TRANSLATE_REJECTED':
      return moveToRejected(state, [action.payload.messageId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
